import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
// import { gamesService } from '../../services/games.service';
import { heroBannerService } from '../../services/hero-banner.service';
import { isCoAdminOrAdmin } from '../../utils/roles';
import vesakMascot from '../../assets/Vesak deco intranet/Gemini_Generated_Image_dzg6r4dzg6r4dzg6.png';
import vesakText1 from '../../assets/Vesak deco intranet/6776a7472e8fba6767edf2547bd4e1b4.png';
import vesakText2 from '../../assets/Vesak deco intranet/7481b5e623db4c2eab1672a764b4d247.png';
import './HeroBanner.css';

interface BannerAnnouncement {
  text: string;
  visible: boolean;
  updatedBy: string;
  updatedAt: string;
}

const HeroCelebrationMedia: React.FC = () => {
  return (
    <video
      className="hero-celebration-media"
      src="/vesak-night-scene.mp4"
      autoPlay
      loop
      muted
      playsInline
      aria-hidden
    />
  );
};

const HeroBanner: React.FC = () => {
  const { user } = useAuth();
  // const navigate = useNavigate();
  const [bannerAnn, setBannerAnn] = useState<BannerAnnouncement | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState('');
  // const [avuruduTotal, setAvuruduTotal] = useState<number>(0);
  // const [avuruduRank, setAvuruduRank] = useState<number | null>(null);

  const isAdmin = isCoAdminOrAdmin(user?.role);

  useEffect(() => {
    if (!user?.id) return;
    let cancelled = false;
    (async () => {
      try {
        const data = await heroBannerService.get();
        if (!cancelled) {
          setBannerAnn({
            text: data.text || '',
            visible: data.visible,
            updatedBy: data.updatedBy || '',
            updatedAt: data.updatedAt,
          });
          try {
            localStorage.removeItem('hero_banner_announcement');
          } catch {
            /* ignore */
          }
        }
      } catch {
        if (!cancelled) setBannerAnn(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  // useEffect(() => {
  //   const fetchAvuruduScore = async () => {
  //     try {
  //       const [myScores, leaderboard] = await Promise.all([
  //         gamesService.getMyScores(),
  //         gamesService.getLeaderboard(),
  //       ]);
  //       setAvuruduTotal(myScores.total ?? 0);
  //       const myEntry = leaderboard.find((e) => e.userId === user?.id);
  //       setAvuruduRank(myEntry?.rank ?? null);
  //     } catch {
  //       setAvuruduTotal(0);
  //       setAvuruduRank(null);
  //     }
  //   };
  //   if (user?.id) fetchAvuruduScore();
  // }, [user?.id]);

  const handleSave = async () => {
    const trimmed = editText.trim();
    if (!trimmed) return;
    try {
      const data = await heroBannerService.update({ text: trimmed, visible: true });
      setBannerAnn({
        text: data.text || '',
        visible: data.visible,
        updatedBy: data.updatedBy || '',
        updatedAt: data.updatedAt,
      });
      setIsEditing(false);
    } catch (err: any) {
      const m = err.response?.data?.message;
      alert(Array.isArray(m) ? m.join(' ') : m || err.message || 'Failed to save note');
    }
  };

  const handleToggleVisibility = async () => {
    if (!bannerAnn) return;
    try {
      const data = await heroBannerService.update({ visible: !bannerAnn.visible });
      setBannerAnn({
        text: data.text || '',
        visible: data.visible,
        updatedBy: data.updatedBy || '',
        updatedAt: data.updatedAt,
      });
    } catch (err: any) {
      const m = err.response?.data?.message;
      alert(Array.isArray(m) ? m.join(' ') : m || err.message || 'Failed to update visibility');
    }
  };

  const handleStartEdit = () => {
    setEditText(bannerAnn?.text || '');
    setIsEditing(true);
  };

  const getGreeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Good Morning';
    if (h < 17) return 'Good Afternoon';
    return 'Good Evening';
  };

  const firstName = user?.fullName?.split(' ')[0] || 'there';
  const hasNote = !!(bannerAnn?.visible && bannerAnn.text);
  const showCard = isAdmin || hasNote;

  return (
    <>
      <div className="hero-banner">
        <div className='hero-celebration-bg' aria-hidden />
        <HeroCelebrationMedia />

        <div className="hero-vesak-text-stack">
          <img src={vesakText2} alt="Vesak Subtext" />
          <img src={vesakText1} alt="Vesak Greeting Text" />
        </div>

        <div className="hero-left">
          {showCard && (
            <div className="hero-announcement-card">
              <div className="hero-ann-dept">
                HR Announcement
              </div>
              {hasNote && (
                <p className="hero-ann-subtext no-border">
                  {bannerAnn!.text}
                </p>
              )}

              {isAdmin && (
                <div className="hero-ann-admin">
                  {isEditing ? (
                    <div className="hero-ann-edit-row">
                      <input
                        className="hero-ann-input"
                        type="text"
                        value={editText}
                        onChange={(e) => setEditText(e.target.value)}
                        placeholder="Add a note..."
                        maxLength={120}
                        onKeyDown={(e) => e.key === 'Enter' && handleSave()}
                        autoFocus
                      />
                      <button className="hero-ann-save-btn" onClick={handleSave}>Save</button>
                      <button className="hero-ann-cancel-btn" onClick={() => setIsEditing(false)}>Cancel</button>
                    </div>
                  ) : (
                    <div className="hero-ann-action-row">
                      <button className="hero-ann-edit-btn" onClick={handleStartEdit}>
                        {bannerAnn?.text ? 'Edit note' : '+ Add note'}
                      </button>
                      {bannerAnn?.text && (
                        <button className="hero-ann-toggle-btn" onClick={handleToggleVisibility}>
                          {bannerAnn.visible ? 'Hide' : 'Show'}
                        </button>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {/* <div className="hero-points-section">
          <div className="hero-points-value">{avuruduTotal.toLocaleString()}</div>
          <div className="hero-points-label">Points</div>
          {avuruduRank !== null && (
            <div className="hero-points-rank">Rank #{avuruduRank}</div>
          )}
        </div> */}

        <div className="hero-mascot-wrapper">
          <img
            src={vesakMascot}
            alt="Vesak Greeting"
            className="hero-mascot-img"
          />
        </div>
      </div>

      <div className="hero-greeting-section">
        <h2 className="hero-greeting">
          {getGreeting()}, {firstName} San ! 👋
        </h2>
        <p className="hero-subtitle">
          Here's what's happening at Toyota Lanka today:
        </p>
      </div>
    </>
  );
};

export default HeroBanner;
